import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=0fe7ee22&scoped=true&"
import script from "./ModalContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ModalContent.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ModalContent.vue?vue&type=style&index=0&id=0fe7ee22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe7ee22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe7ee22')) {
      api.createRecord('0fe7ee22', component.options)
    } else {
      api.reload('0fe7ee22', component.options)
    }
    module.hot.accept("./ModalContent.vue?vue&type=template&id=0fe7ee22&scoped=true&", function () {
      api.rerender('0fe7ee22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentRestrictions/components/ModalContent.vue"
export default component.exports